import { render, staticRenderFns } from "./Flavors.vue?vue&type=template&id=5d3dddc3&scoped=true&"
import script from "./Flavors.vue?vue&type=script&lang=js&"
export * from "./Flavors.vue?vue&type=script&lang=js&"
import style0 from "./Flavors.vue?vue&type=style&index=0&id=5d3dddc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3dddc3",
  null
  
)

export default component.exports